import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
interface PortfolioSnapshotProps {
  data: {
    totalFunded: number;
    outstanding: number;
    weightedTenor: number;
    currentYield: number;
    portfolioHealth: number;
  };
  phase: number;
  isRecomputing?: boolean;
}
export function PortfolioSnapshot({
  data,
  phase,
  isRecomputing
}: PortfolioSnapshotProps) {
  const formatCurrency = (value: number) => {
    return `$${(value / 1000000).toFixed(1)}M`;
  };
  const metrics = [{
    label: 'Total Funded',
    value: formatCurrency(data.totalFunded),
    color: 'text-slate-300'
  }, {
    label: 'Outstanding',
    value: formatCurrency(data.outstanding),
    color: 'text-blue-400',
    updates: true
  }, {
    label: 'Weighted Tenor',
    value: `${data.weightedTenor}d`,
    color: 'text-slate-300',
    updates: true
  }, {
    label: 'Current Yield',
    value: `${data.currentYield.toFixed(1)}%`,
    color: 'text-emerald-400',
    updates: true
  }, {
    label: 'Portfolio Health',
    value: `${data.portfolioHealth.toFixed(1)}%`,
    color: 'text-emerald-400'
  }];
  return <div className={`bg-slate-900 border rounded p-3.5 h-full transition-colors ${isRecomputing ? 'border-emerald-500/50' : 'border-slate-800'}`} data-id="element-153">
      <div className="flex items-center justify-between mb-3 pt-2" data-id="element-154">
        <h3 className="text-base font-semibold text-slate-300 tracking-tight" data-id="element-155">
          Portfolio Snapshot
        </h3>
        <TrendingUpIcon size={16} className="text-slate-600" data-id="element-156" />
      </div>

      <div className="space-y-3" data-id="element-157">
        {metrics.map((metric, index) => <motion.div key={metric.label} initial={{
        opacity: 0,
        x: -10
      }} animate={{
        opacity: phase >= 1 ? 1 : 0,
        x: phase >= 1 ? 0 : -10
      }} transition={{
        delay: index * 0.05,
        duration: 0.2
      }} className="border-b border-slate-800 pb-2 last:border-b-0" data-id="element-158">
            <div className="text-[10px] text-slate-500 uppercase tracking-wide mb-1" data-id="element-159">
              {metric.label}
            </div>
            <motion.div key={metric.value} initial={{
          scale: 1
        }} animate={{
          scale: phase >= 8 && metric.updates || isRecomputing ? [1, 1.08, 1] : 1
        }} transition={{
          duration: 0.4
        }} className={`text-[26px] font-mono font-semibold leading-none ${metric.color} ${isRecomputing && metric.updates ? 'text-emerald-400' : ''}`} data-id="element-160">
              {metric.value}
            </motion.div>
          </motion.div>)}
      </div>

      {phase >= 1 && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3,
      duration: 0.2
    }} className="mt-3 pt-3 border-t border-slate-800" data-id="element-161">
          <div className="flex items-center gap-2 text-[10px] text-slate-500" data-id="element-162">
            <span className={`inline-block h-1 w-1 rounded-full animate-pulse ${isRecomputing ? 'bg-emerald-400' : 'bg-emerald-500'}`} data-id="element-163" />
            <span className="font-mono" data-id="element-164">
              {isRecomputing ? 'Recomputing...' : 'Live feed from Mint rail'}
            </span>
          </div>
        </motion.div>}
    </div>;
}